import { render, staticRenderFns } from "./LeftSideBar.vue?vue&type=template&id=f4f52374&scoped=true&"
import script from "./LeftSideBar.vue?vue&type=script&lang=js&"
export * from "./LeftSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f52374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4f52374')) {
      api.createRecord('f4f52374', component.options)
    } else {
      api.reload('f4f52374', component.options)
    }
    module.hot.accept("./LeftSideBar.vue?vue&type=template&id=f4f52374&scoped=true&", function () {
      api.rerender('f4f52374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/LeftSideBar/LeftSideBar.vue"
export default component.exports